import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Menu from "Menu/Menu";
import { TTP_LOGO_URL } from "Config";
import { selectUserCommunities } from "Selectors";
import { setNavCommunity } from "Actions";
import { changeNavCommunity } from "Thunks";

import Community from "./Community";

export class SelectCommunity extends PureComponent {
  static defaultProps = {
    communities: []
  };

  static propTypes = {
    communities: PropTypes.array,
    setNavCommunity: PropTypes.func
  };

  handleSelectCommunity = community => {
    const { changeNavCommunity, setNavCommunity } = this.props;
    setNavCommunity(community);
    changeNavCommunity(community.id);
  };

  renderCommunities() {
    const { communities } = this.props;

    return communities.map(c => (
      <Community
        key={c.id}
        community={c}
        onClick={this.handleSelectCommunity.bind(this, c)}
      />
    ));
  }

  render() {
    return (
      <div id="select-community">
        <Menu />
        <div className="sc__container">
          <span className="sc__logo">
            <img src={TTP_LOGO_URL} alt="logo" />
          </span>
          <div className="sc__communities grid-x grid-margin-x">
            {this.renderCommunities()}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  communities: selectUserCommunities(state)
});

const mapDispatchToProps = dispatch => ({
  setNavCommunity: community => dispatch(setNavCommunity(community)),
  changeNavCommunity: communityId => dispatch(changeNavCommunity(communityId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCommunity);



// WEBPACK FOOTER //
// ./src/components/SelectCommunity/SelectCommunity.js